/**
 * B2B Mobile Header — Drawer navigation with panel drill-down + accordions
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    // ====== CLONE ANNOUNCEMENT BAR INTO DRAWER ======
    var announcementSource = document.querySelector('.announcement-bar-section');
    var announcementSlot = document.querySelector('[data-drawer-announcement-slot]');
    if (announcementSource && announcementSlot) {
      var clone = announcementSource.cloneNode(true);
      clone.removeAttribute('id');
      clone.classList.add('b2b-mobile-header__announcement-clone');
      announcementSlot.appendChild(clone);
    }

    // ====== SYNC ICONS FROM HEADER TOP TO MOBILE + SEARCH POPUP ======
    var headerIcons = document.querySelector('.header-top__icons');
    if (headerIcons) {
      // Get icon sources from header top
      var searchIcon = headerIcons.querySelector('[aria-label="Search"] img, [aria-label="Search"] svg');
      var wishlistIcon = headerIcons.querySelector('[aria-label="Wishlist"] img, [aria-label="Wishlist"] svg');
      var cartIcon = headerIcons.querySelector('[aria-label="Cart"] img, [aria-label="Cart"] svg');

      // Sync mobile header bar search icon
      var mobileSearchIcon = document.querySelector('.b2b-mobile-header__bar-right [aria-label="Search"]');
      if (mobileSearchIcon && searchIcon) {
        mobileSearchIcon.innerHTML = '';
        mobileSearchIcon.appendChild(searchIcon.cloneNode(true));
      }

      // (The mobile drawer's top icon is the Account link; the cart icon now
      // lives in the always-visible mobile top bar and is rendered by Liquid.)

      // Sync search popup wishlist icon
      var popupWishlistIcon = document.querySelector('.search-popup__icons [aria-label="Wishlist"]');
      if (popupWishlistIcon && wishlistIcon) {
        popupWishlistIcon.innerHTML = '';
        popupWishlistIcon.appendChild(wishlistIcon.cloneNode(true));
      }

      // Sync search popup cart icon
      var popupCartIcon = document.querySelector('.search-popup__icons [aria-label="Cart"]');
      if (popupCartIcon && cartIcon) {
        // Keep cart count badge
        var badge = popupCartIcon.querySelector('.cart-count-bubble');
        popupCartIcon.innerHTML = '';
        popupCartIcon.appendChild(cartIcon.cloneNode(true));
        if (badge) popupCartIcon.appendChild(badge);
      }
    }

    var drawer = document.querySelector('[data-b2b-mobile-drawer]');
    var overlay = document.querySelector('[data-b2b-mobile-overlay]');
    var openBtns = document.querySelectorAll('[data-b2b-mobile-open]');
    var closeBtns = document.querySelectorAll('[data-b2b-mobile-close]');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('b2b-mobile-drawer-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('b2b-mobile-drawer-open');
      document.body.style.overflow = '';

      // Reset to main panel after close animation
      setTimeout(function () {
        var panels = drawer.querySelectorAll('.b2b-mobile-header__panel');
        panels.forEach(function (panel) {
          panel.classList.remove('b2b-mobile-header__panel--active', 'b2b-mobile-header__panel--exiting');
        });
        var mainPanel = drawer.querySelector('[data-panel="main"]');
        if (mainPanel) mainPanel.classList.add('b2b-mobile-header__panel--active');
      }, 400);
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Escape to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Panel navigation (drill-down)
    var panelButtons = drawer.querySelectorAll('[data-open-panel]');
    panelButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetPanelId = btn.getAttribute('data-open-panel');
        var targetPanel = drawer.querySelector('[data-panel="' + targetPanelId + '"]');
        var currentPanel = drawer.querySelector('.b2b-mobile-header__panel--active');

        if (targetPanel && currentPanel && targetPanel !== currentPanel) {
          currentPanel.classList.add('b2b-mobile-header__panel--exiting');
          currentPanel.classList.remove('b2b-mobile-header__panel--active');
          targetPanel.classList.add('b2b-mobile-header__panel--active');

          setTimeout(function () {
            currentPanel.classList.remove('b2b-mobile-header__panel--exiting');
          }, 400);
        }
      });
    });

    // Back button
    var backButtons = drawer.querySelectorAll('[data-panel-back]');
    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var backTo = btn.getAttribute('data-panel-back') || 'main';
        var targetPanel = drawer.querySelector('[data-panel="' + backTo + '"]');
        var currentPanel = btn.closest('.b2b-mobile-header__panel');

        if (targetPanel && currentPanel && targetPanel !== currentPanel) {
          currentPanel.classList.remove('b2b-mobile-header__panel--active');
          targetPanel.style.transform = 'translateX(-20%)';
          targetPanel.classList.add('b2b-mobile-header__panel--active');

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              targetPanel.style.transform = '';
            });
          });
        }
      });
    });

    // Accordions
    var accordionToggles = drawer.querySelectorAll('.b2b-mobile-header__accordion-toggle');
    accordionToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var content = toggle.nextElementSibling;
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          toggle.setAttribute('aria-expanded', 'false');
          content.classList.remove('is-open');
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          content.classList.add('is-open');
        }
      });
    });
  });
})();
